import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Menu, Icon, Avatar } from 'antd'
import { toggleSideBarCollapsed } from '../../modules/settings'
import { signOut } from '../../modules/auth'
import { setLocale } from '../../modules/intl'
import { FormattedMessage } from 'react-intl'
import apis from '../../config/apis'

import './index.css'

const { SubMenu, Item } = Menu

class NavBar extends Component {

    render() {
        return (
            <div className="navbar">
                <Menu
                    mode="horizontal"
                    selectable={false}
                    style={{ lineHeight: '64px', paddingBottom: 0 }}
                >
                    <Item onClick={this.props.toggle}>
                        <Icon type={this.props.collapsed ? 'menu-unfold' : 'menu-fold'} style={{ margin: 0 }} />
                    </Item>
                    <SubMenu style={{ float: 'right' }} title={
                        <div>
                            <Avatar style={{ marginRight: 10 }} src={`${apis.avatar.url}/${this.props.user.picture}`}>
                                {this.props.user.name && this.props.user.name[0].toUpperCase()}
                                {this.props.user.lastName && this.props.user.lastName[0].toUpperCase()}
                            </Avatar>
                            {`${this.props.user.name} ${this.props.user.lastName}`}
                        </div>
                    }>
                        <Item onClick={this.props.signOut}><FormattedMessage id={'Navbar.signOut'} /></Item>
                    </SubMenu>
                    {/* <Item style={{ float: 'right' }}><Icon type="bell" style={{ margin: 0 }} /></Item> */}
                    <SubMenu style={{ float: 'right' }} title={<Icon type="global" style={{ margin: 0 }} />}>
                        <Item onClick={() => { this.props.setLocale('es') }}>Español</Item>
                        <Item onClick={() => { this.props.setLocale('en') }}>English</Item>
                    </SubMenu>
                </Menu>
            </div>
        )
    }

}

const mapStateToProps = state => ({
    user: state.auth.user,
    collapsed: state.settings.sideBarCollapsed,
    locale: state.intl.locale
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setLocale,
    toggle: toggleSideBarCollapsed,
    signOut,
}, dispatch)

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(NavBar)
)


// WEBPACK FOOTER //
// ./src/containers/NavBar/index.js